var _defs, _mask, _g, _defs2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: "80px",
    height: "80px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DB4437",
    d: "M2 0v14.7h5.3L12 6.5h12V0H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M2 0v14.7h5.3L12 6.5h12V0H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F9D58",
    d: "M0 24h11.4l5.3-5.3v-4H7.3L0 2.2V24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear)",
    d: "M0 24h11.4l5.3-5.3v-4H7.3L0 2.2V24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3E2723",
    fillOpacity: 0.1,
    d: "M7.4 14.7L2 5.4l-.1.1 5.4 9.2h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillOpacity: 0.1,
    d: "M16.6 15l-.1-.2-5.2 9.2h.1l5.2-9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_radial)",
    d: "M12 6.5v2.9l10.7-2.9H12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_radial)",
    fillRule: "evenodd",
    d: "M22.7 6.5H12l-4.7 8.2H1.9V5.5a12 12 0 1020.8 1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_radial)",
    d: "M12 24a12 12 0 100-24 12 12 0 000 24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD40",
    d: "M12 6.5l4.7 8.2-5.3 9.3H24V6.5H12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_linear)",
    d: "M12 6.5l4.7 8.2-5.3 9.3H24V6.5H12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_radial)",
    d: "M2 5.5l7.7 7.8-2.4 1.4-5.4-9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint7_radial)",
    d: "M11.4 24l2.9-10.7 2.4 1.4-5.3 9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M12 17.5a5.5 5.5 0 100-11 5.5 5.5 0 000 11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M12 16.4a4.4 4.4 0 100-8.8 4.4 4.4 0 000 8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3E2723",
    fillOpacity: 0.2,
    d: "M12 6.4C9 6.4 6.5 9 6.5 12v.1C6.5 9 9 6.5 12 6.5h12-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.1,
    d: "M16.7 14.7a5.4 5.4 0 01-9.4 0L0 2.2v.2l7.3 12.5a5.4 5.4 0 009.4 0v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3E2723",
    d: "M12.1 6.5a5.5 5.5 0 010 11 5.5 5.5 0 000-11z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "M16.8 15a5.4 5.4 0 00.4-4.5 5.5 5.5 0 01-.5 4.2L11.4 24h.2l5.2-9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "M12 .1a12 12 0 0112 12V12a12 12 0 00-24 0A12 12 0 0112 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3E2723",
    fillOpacity: 0.1,
    d: "M12 23.9a12 12 0 0012-12v.1a12 12 0 01-24 0 12 12 0 0012 11.9z"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(11.5 6.5) scale(11.4652)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2723",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(3.6 3.3) scale(24.1023)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(3.6 3.3) scale(24.1023)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(1.9 5.5) scale(10.6424)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2723",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(12 12) scale(11.9823)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 2.9,
    x2: 10.1,
    y1: 9.1,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A52714",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#A52714",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 14,
    x2: 6.1,
    y1: 21.3,
    y2: 16.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055524",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#055524",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 15.5,
    x2: 17.5,
    y1: 5.7,
    y2: 14.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA6100",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EA6100",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/Chrome.a09b6198865a0ba219485dbdea9302c0.svg";
export { ForwardRef as ReactComponent };